define('views/modules/setting/business/blocks/custom-button/custom-button-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/setting/business/blocks/custom-button/custom-button-edit-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VCustomButtonEditContent
) {

    var VCustomButtonEditPanel = VBasePanel.extend({
        header: {
            title: "Edit my custom button",
            subtitle: "Personalize its behavior",
        },

        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        content: {
            edit: VCustomButtonEditContent,
        },
        defaultView: 'edit',

        initialize: function(opt) {
            opt = opt || {};

            var edit = this.getView('edit', {
                model: this.model
            });

            this.listenTo(edit, { 'form:success': this.close });
        },

    });

    return VCustomButtonEditPanel;

});

